module.exports = __webpack_public_path__ + "app/assets/fonts/st-icons-web.svg?88f9198d49df5160946a9036ddaa9fcf";


//////////////////
// WEBPACK FOOTER
// ./~/@suntransfers/st-ui/dist/styles/fonts/st-icons-web.svg
// module id = 183
// module chunks = 1